import {
    SearchFrm,
    SearchInput,
    SearchSubmit,
    SearchIc
} from './searchFormElements'
import { useHistory } from 'react-router-dom'
import { useState } from 'react'

const SearchForm = () => {
    const history = useHistory()
    const [q, setQ] = useState(null)
    const handleInputChange = e => setQ(e.target.value)
    const handleSubmit = e => {
        e.preventDefault()
        if(!q) return;
        history.push({
            pathname: '/search',
            search: `?q=${q}`
        })
    }
    return (
        <SearchFrm onSubmit={handleSubmit}>
            <SearchInput onChange={handleInputChange} name="q" type="text" placeholder="Tìm kiếm tin tức" />
            <SearchSubmit type="submit"><SearchIc /></SearchSubmit>
        </SearchFrm>
    )
}

export default SearchForm
